var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__img mb-2"}),_c('span',{staticClass:"feta ekas"},[_vm._v("Страница не существует или была удалена")])])
}]

export { render, staticRenderFns }